import { coreCustomersByIdGetSlice } from './get';
import { coreCustomersByIdPatchSlice } from './patch';

export * from './feature-flags/actions';
export * from './users/actions';

export const {
	requestPatchCoreCustomersById,
	resetPatchCoreCustomersById
} = coreCustomersByIdPatchSlice.asyncActionCreators;

export const {
	requestGetCoreCustomersById,
	resetGetCoreCustomersById
} = coreCustomersByIdGetSlice.asyncActionCreators;
